import {Fragment, useEffect, useState} from "react";
import {
    checkHSCodeInValid,
    getCountryCode,
    getMissingKeysFromObject,
    hasChinese,
    isValidTariffCode
} from "../../Utils/Helper";
import {HSCode, PARTNER_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {
    Box, Button, CircularProgress,
    FormControl,
    FormLabel,
    Grid, IconButton,
    InputAdornment,
    Link,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CheckIcon from '@mui/icons-material/Check';
import {green} from "../../Utils/style";

export const WordPressQuoteCustomsItemList = ({
                                                  cbHandleShippingDetails,
                                                  validatedResult,
                                                  lng,
                                                  movingFrom,
                                                  movingTo,
                                                  HSCodeError,
                                                  validateEmailAddress,
                                                  cbHandleValidatedEmail,
                                                  contact
                                              }) => {

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lookUpHSCode, setLookUpHSCode] = useState([]);
    const [lookUpHSCodeError, setLookUpHSCodeError] = useState(false);
    const [isCallHSCode, setIsCallHSCode] = useState(false);
    const [index, setIndex] = useState(0);

    const [customsItemDetail, setCustomsItemDetail] = useState({
        description: '',
        UOM: 'Each',
        hscode: null,
        originCountryCode: 'CN',
        currency: 'CAD',
        priceEach: null,
        quantity: 1,
        desc_en: '',
        desc_cn_gb: '',
    });

    const handleDescription = event => {
        const {value} = event.target;
        setCustomsItemDetail(prevState => ({
            ...prevState,
            description: value
        }))
    }

    const handleQuantity = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            // const maximum = 10;
            setCustomsItemDetail(prevState => ({
                ...prevState,
                quantity: value
            }))
        }
    }

    const handleCurrency = event => {
        setCustomsItemDetail(prevState => ({
            ...prevState,
            currency: event.target.value
        }))
    }

    const handlePrice = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setCustomsItemDetail(prevState => ({
                ...prevState,
                priceEach: value
            }))
        }
    }

    const handleCountryCode = event => {
        setCustomsItemDetail(prevState => ({
            ...prevState,
            originCountryCode: event.target.value,
        }))
    }

    const handleHSCode = event => {
        const {value} = event.target;

        // Regular expression to allow only numbers and periods
        const regex = /^[0-9.]+$/;
        if (value === '' || regex.test(value)) {
            setCustomsItemDetail(prevState => ({
                ...prevState,
                hscode: event.target.value
            }))
        }
    }

    const handleNextHSCode = () => {
        setIndex(prevState => {
                const newIndex = prevState + 1;
                return newIndex === lookUpHSCode.length ? 0 : newIndex;
            }
        );
    }

    const handleSelectHSCode = () => {
        setCustomsItemDetail(prevState => ({
            ...prevState,
            desc_en: lookUpHSCode[index]?.desc_en,
            desc_cn_gb: lookUpHSCode[index]?.desc_cn_gb,
            hscode: lookUpHSCode[index]?.hscode
        }))
    }

    const handleHSCodeLookup = async () => {
        setLookUpHSCode([]);
        setLookUpHSCodeError(false);
        setIsCallHSCode(false);
        const descriptionError = getMissingKeysFromObject({
            description: customsItemDetail?.description,
            exportCountry: movingFrom?.country,
            importCountry: movingTo?.country,
            originCountry: customsItemDetail?.originCountryCode
        });
        setError(descriptionError?.length > 0);
        const contactEmailCheck = await validateEmailAddress(contact?.email);
        cbHandleValidatedEmail(contactEmailCheck);
        if (descriptionError?.length === 0 && contactEmailCheck?.valid) {
            await searchHSCodeFromElasticSearch();
        }
    }

    const searchHSCodeFromElasticSearch = async () => {
        try {
            setLoading(true);
            setIsCallHSCode(true);

            const requestURL = `${PARTNER_URI}/elasticsearch/hsCode/searchHSCodeListFromAI`

            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    queryString: customsItemDetail?.description,
                    exportCountry: movingFrom?.country,
                    importCountry: movingTo?.country,
                    originCountry: customsItemDetail?.originCountryCode,
                    pageSize: 5,
                    userEmail: contact?.email
                }
            });

            console.log('[searchHSCodeFromElasticSearch] result', result);
            setLookUpHSCode(result?.data?.result);
            setLookUpHSCodeError(false);

        } catch (e) {
            console.log('[searchHSCodeFromElasticSearch] error', error);
            setLookUpHSCodeError(true)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        cbHandleShippingDetails(customsItemDetail);
    }, [customsItemDetail]);

    return (
        <Fragment>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? "数量" : "Quantity"}
                    </FormLabel>
                    <TextField
                        value={customsItemDetail?.quantity}
                        onInput={handleQuantity}
                        fullWidth
                        variant='outlined'
                        type='number'
                        size='small'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        error={validatedResult !== null && (+customsItemDetail?.quantity <= 0 || !customsItemDetail?.quantity || (+customsItemDetail?.quantity * +customsItemDetail?.priceEach > 1000000))}
                        helperText={validatedResult !== null &&
                            (!customsItemDetail?.quantity ? (lng === 'cn' ? "必填" : "Required") :
                                +customsItemDetail?.quantity <= 0 ? (lng === 'cn' ? "无效" : "Invalid") :
                                    +customsItemDetail?.quantity * +customsItemDetail?.priceEach > 1000000 && (lng === 'cn' ? "总价值高于 1,000,000" : "Total value exceeds 1,000,000"))}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl required fullWidth>
                    <FormLabel sx={{textAlign: 'left'}}>
                        {lng === 'cn' ? "货币" : "Currency"}
                    </FormLabel>
                    <Select
                        sx={{
                            '& .MuiSelect-select': {
                                fontSize: '14px' // Set your desired font size here
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '5px 14px', // Removes inner padding
                            },
                        }}
                        value={customsItemDetail?.currency}
                        size='small'
                        onChange={handleCurrency}
                    >
                        <MenuItem value='CAD'>CAD</MenuItem>
                        <MenuItem value='USD'>USD</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormLabel required sx={{textAlign: 'left'}}>
                        {lng === 'cn' ? "单价" : "Unit Price"}
                    </FormLabel>
                    <TextField
                        value={customsItemDetail?.priceEach}
                        size='small'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        type='number'
                        onInput={handlePrice}
                        error={validatedResult !== null && (+customsItemDetail?.priceEach <= 0 || !customsItemDetail?.priceEach || +customsItemDetail?.quantity * +customsItemDetail?.priceEach > 1000000)}
                        helperText={validatedResult !== null &&
                            (!customsItemDetail?.priceEach ? (lng === 'cn' ? "必填" : "Required") :
                                +customsItemDetail?.priceEach <= 0 ? (lng === 'cn' ? "无效" : "Invalid") :
                                    +customsItemDetail?.quantity * +customsItemDetail?.priceEach > 1000000 && (lng === 'cn' ? "总价值高于 1,000,000" : "Total value exceeds 1,000,000"))}
                    >
                    </TextField>
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormLabel required sx={{textAlign: 'left'}}>
                        {lng === 'cn' ? "原产国" : "Origin Country"}
                    </FormLabel>
                    <Select
                        sx={{
                            '& .MuiSelect-select': {
                                fontSize: '14px' // Set your desired font size here
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '5px 14px', // Removes inner padding
                            },
                        }}
                        value={customsItemDetail?.originCountryCode}
                        size='small'
                        onChange={handleCountryCode}
                        error={!customsItemDetail?.originCountryCode}
                    >
                        {
                            getCountryCode()?.map(v => {
                                return <MenuItem value={v.code}>{v.name}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 8}}>
                <FormControl fullWidth>
                    <FormLabel sx={{textAlign: 'left'}}>
                        {lng === 'cn' ? "商品描述" : "Product Description"}
                    </FormLabel>
                    <TextField
                        value={customsItemDetail?.description}
                        placeholder={lng === 'cn' ? "类别（例如：衣服，工具），适用对象（男/女或男童/女童），材质，品牌，尺寸/容量" : "Category (e.g., cloth, tool), For (Men/Boy or Women/Girl), Material, Brand, Size/Volume"}
                        size='small'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        // multiline
                        onInput={handleDescription}
                        error={error}
                        helperText={error && (lng === 'cn' ? "商品描述缺失" : "Product Description Missing")}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
                <FormControl fullWidth>
                    <FormLabel required sx={{textAlign: 'left'}}>
                        {lng === 'cn' ? "HS编码" : "HS Code"}
                        <span><Link underline="none" target="_blank"
                                    rel="noreferrer" href={HSCode}><HelpIcon
                            sx={{color: green, fontSize: '16px'}}/></Link></span>
                    </FormLabel>
                    <TextField
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        value={customsItemDetail?.hscode}
                        size='small'
                        onInput={handleHSCode}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Box sx={{display: 'flex'}}>
                                        <Button
                                            startIcon={<SearchIcon sx={{color: '#454545'}}/>}
                                            onClick={handleHSCodeLookup}
                                        >
                                            <Typography
                                                sx={{
                                                    textTransform: 'none',
                                                    color: '#1D8B45',
                                                    fontSize: '14px'
                                                }}>
                                                {lng === 'cn' ? "HS编码查询" : "HS Code Lookup"}
                                            </Typography>
                                        </Button>
                                    </Box>
                                </InputAdornment>
                            )
                        }}
                        error={(validatedResult !== null && (!customsItemDetail?.hscode || !isValidTariffCode(customsItemDetail?.hscode))) || checkHSCodeInValid(HSCodeError?.errors, customsItemDetail?.hscode)}
                        helperText={(validatedResult !== null && !customsItemDetail?.hscode) ? (lng === 'cn' ? "必填" : "Required") :
                            (validatedResult !== null && !isValidTariffCode(customsItemDetail?.hscode)) ? (lng === 'cn' ? "正确的格式必须至少为8位数字（9999.99.99），推荐使用10位数字（9999.99.99.99）的标准格式" : "The correct format must be at least 8 digits (9999.99.99), with 10 digits (9999.99.99.99) being the recommended standard") :
                                checkHSCodeInValid(HSCodeError?.errors, customsItemDetail?.hscode) && (lng === 'cn' ? "HS编码无效" : "HS Code is invalid")
                        }
                    />
                </FormControl>
            </Grid>
            {
                isCallHSCode &&
                (
                    loading ?
                        <Grid size={{xs: 12}}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <CircularProgress/>
                            </Box>
                        </Grid>
                        :
                        lookUpHSCode?.length > 0 ?
                            <Fragment>
                                <Grid size={{xs: 2}}>
                                    <Typography sx={{fontSize: '14px'}}>
                                        {lookUpHSCode[index]?.hscode}
                                    </Typography>
                                </Grid>
                                <Grid size={{xs: 8}}>
                                    <Grid container spacing={1}>
                                        <Grid size={{xs: 12}}>
                                            <Typography sx={{fontSize: '14px'}}>
                                                {lookUpHSCode[index]?.desc_en}
                                            </Typography>
                                        </Grid>
                                        {
                                            hasChinese(customsItemDetail?.description) &&
                                            <Grid size={{xs: 12}}>
                                                <Typography sx={{fontSize: '14px'}}>
                                                    {lookUpHSCode[index]?.desc_cn_gb}
                                                </Typography>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid size={{xs: 2}}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'flex-end',
                                        gap: '5px'
                                    }}>
                                        {
                                            lookUpHSCode?.length > 1 &&
                                            <IconButton
                                                onClick={handleNextHSCode}
                                            >
                                                <Typography sx={{fontSize: '14px', color: green}}>
                                                    {lng === 'cn' ? "下一个" : "Next"}
                                                </Typography>
                                                <NavigateNextIcon style={{color: green}}/>
                                            </IconButton>
                                        }
                                        <IconButton
                                            onClick={handleSelectHSCode}
                                        >
                                            <Typography sx={{fontSize: '14px', color: green}}>
                                                {lng === 'cn' ? "选择" : "Select"}
                                            </Typography>
                                            <CheckIcon style={{color: green}}/>
                                        </IconButton>
                                    </Box>
                                </Grid>
                            </Fragment>
                            :
                            <Grid size={{xs: 12}}>
                                <Typography sx={{fontSize: '14px'}}>
                                    {lng === 'cn' ? "无可用HS编码" : "No HS Code Available"}
                                </Typography>
                            </Grid>
                )
            }
        </Fragment>
    )
}